export default __webpack_public_path__ + "static/photo-remi-papon-ed3b0f4d4bab50212b538c6dbc31f5ec.webp";